<template>
  <div class="Review_key">
    <h2 style="padding-top: 20px;margin-left: 20px;">学生基本信息</h2>
    <ul class="Review_key_basic">
      <li><span></span> 姓名：关于</li>
      <li><span></span> 学号：26232</li>
      <li><span></span> 所在院系：中国科学眼</li>
      <li><span></span> 心理辅导员联系方式13562533362</li>
    </ul>
    <h2 style="padding-top: 40px;margin-left: 20px;padding-bottom: 10px;">危机评估</h2>
    <el-form ref="form" :model="form" label-width="80px">

      <el-form-item class="list1" label="意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）：">
        <el-input v-model="form.a1"></el-input>
      </el-form-item>

      <el-form-item class="list2" label="所处情境（所处位置/周围环境）：">
        <el-input v-model="form.a2"></el-input>
      </el-form-item>

      <el-form-item class="list3" label="自知力：">
        <el-input v-model="form.a3"></el-input>
      </el-form-item>

      <el-form-item class="list4" label="情绪状态（类型/强度等）：">
        <el-input v-model="form.a4"></el-input>
      </el-form-item>

      <el-form-item class="list5" label="主要压力源（应激事件/应激反应）：">
        <el-input v-model="form.a5"></el-input>
      </el-form-item>

      <h2 style="padding-top: 20px;margin-left: 20px;padding-bottom: 10px;">危机状态</h2>

     

      
      <el-form-item class="list6" label="活动性质">
        <el-checkbox-group v-model="form.a6">
          <el-checkbox label="1" name="type">红色预警</el-checkbox>
          <el-checkbox label="2" name="type">橙色预警</el-checkbox>
          <el-checkbox label="3" name="type">黄色预警</el-checkbox>
          <el-checkbox label="4" name="type">蓝色预警</el-checkbox>
          <el-checkbox label="5" name="type">绿色预警</el-checkbox>
          <el-checkbox label="6" name="type">无法确定</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="padding-top: 20px;margin-left: 20px;padding-bottom: 10px;">具体风险情况</h2>

      <el-form-item class="list7">
        <el-checkbox-group v-model="form.a7" @change = Risk_situation()>
          <el-checkbox label="1" name="type">自杀、自伤或伤害他人倾向</el-checkbox>
          <el-checkbox label="2" name="type">疑似重性精神病</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="list8" label="自杀、自伤或伤害他人倾向(关于伤害的情况): ">
        <el-checkbox-group v-model="form.a8">
          <el-checkbox label="1" name="type">自杀想法</el-checkbox>
          <el-checkbox label="2" name="type">自杀计划</el-checkbox>
          <el-checkbox label="3" name="type">自杀未遂</el-checkbox>
          <el-checkbox label="4" name="type">自杀实施中</el-checkbox>
          <el-checkbox label="5" name="type">自杀姿态</el-checkbox>
          <el-checkbox label="6" name="type">被动自杀</el-checkbox>
          <el-checkbox label="6" name="type">自伤自残</el-checkbox>
          <el-checkbox label="6" name="type">伤害他人</el-checkbox>
          <el-checkbox label="6" name="type">扩大性自杀</el-checkbox>
          <el-checkbox label="6" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="list9" label="关于自杀方式：">
        <el-checkbox-group v-model="form.a9">
          <el-checkbox label="1" name="type">吞咽</el-checkbox>
          <el-checkbox label="2" name="type">切割</el-checkbox>
          <el-checkbox label="3" name="type">跳楼</el-checkbox>
          <el-checkbox label="4" name="type">服药</el-checkbox>
          <el-checkbox label="5" name="type">其他</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="list10" label="既往自杀相关经历（来访者/重要关系人）：">
        <el-input v-model="form.a10"></el-input>
      </el-form-item>

      <el-form-item class="list11" label="具体描述时间、情况、进程等：">
        <el-input v-model="form.a11"></el-input>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
export default {
  data(){
    return {
      form: {
        a1:'',
        a2:'',
        a3:'',
        a4:'',
        a5:'',
        a6:["1","2"],
        a7:[],
        a8:[],
        a9:[],
        a10:'',
        a11:'',
        a12:'',
        a13: '',
      }
    }
  },
  methods:{
    Risk_situation() {//具体风险情况

    }
  },
  mounted() {

  }
}
</script>

<style>
.Review_key{height: 100%;width: 100%;background-color: #fff;overflow: auto;}
.Review_key_basic {padding-top: 20px;}
.Review_key_basic li{width: 20%;float: left;}
.Review_key_basic li span{width: 20px;margin-left: 20px;}
.Review_key .el-input__inner{    width: 50% !important;}
.Review_key .list1 .el-form-item__label{width: 445px !important;}
.Review_key .list1 .el-form-item__content{margin-left: 445px !important;}
.Review_key .list2 .el-form-item__label{width: 250px !important;}
.Review_key .list2 .el-form-item__content{margin-left: 250px !important;}
.Review_key .list3 .el-form-item__label{width: 92px !important;}
.Review_key .list3 .el-form-item__content{margin-left: 92px !important;}
.Review_key .list4 .el-form-item__label{width: 214px !important;}
.Review_key .list4 .el-form-item__content{margin-left: 214px !important;}
.Review_key .list5 .el-form-item__label{width: 272px !important;}
.Review_key .list5 .el-form-item__content{margin-left: 272px !important;}
.Review_key .list6 .el-form-item__label{width: 92px !important;}
.Review_key .list6 .el-form-item__content{margin-left: 92px !important;}
.Review_key .list7 .el-form-item__label{width: 0px !important;}
.Review_key .list7 .el-form-item__content{margin-left: 20px !important;}
.Review_key .list8 .el-form-item__label{width: 314px !important;}
.Review_key .list8 .el-form-item__content{margin-left: 150px !important;}
.Review_key .list9 .el-form-item__label{width: 314px !important;}
.Review_key .list9 .el-form-item__content{margin-left: 136px !important;}
.Review_key .list10 .el-form-item__label{width: 310px !important;}
.Review_key .list10 .el-form-item__content{margin-left: 310px !important;}
.Review_key .list11 .el-form-item__label{width: 236px !important;}
.Review_key .list11 .el-form-item__content{margin-left: 236px !important;}
</style>